
import Divider from 'vux/src/components/divider/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XTable from 'vux/src/components/x-table/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'

export default {
components: {
Divider,
XInput,
Group,
Cell,
Search,
XButton,
Flexbox,
Card,
FlexboxItem,
XTable,
LoadMore
},
methods: {
clear () {
this.p_name = ''
this.type = ''
this.queryResult = {Data: [], TotalPage: 0}
},
async next () {
this.currentPage--
await this.doQuery()
},
async perv () {
this.currentPage++
await this.doQuery()
},
async doQuery () {
if (this.type === '') {
this.$vux.alert.show({
title: '警告',
content: '请选择类别'})
return
}
if (this.p_name === '') {
this.$vux.alert.show({
title: '警告',
content: '请输入查询条件'})
return
}
try {
this.$vux.loading.show({ text: ' 数据载入中' })
const queryPromise = await this.$http.get('/API/DeclareKeyElement/Stat'
, {params: {type: this.type, p_name: this.p_name, pageNumber: this.currentPage}})
this.queryResult = queryPromise.data
this.$vux.loading.hide()
if (this.queryResult.Data.length === 0) {
this.$vux.alert.show({
title: '通知',
content: '没有符合条件的记录'})
return
}
} catch (err) {
this.$vux.loading.hide()
this.$vux.alert.show({
title: '请求失败',
content: err.message })
}
},
showDesc (index) {
try {
let current = this.queryResult.Data[index]
this.$router.push({path: 'DeclareKeyElementDetail', query: {p_code: current.Item.CODE_TS, p_name: current.Item.G_NAME}})
} catch (err) {
this.$vux.alert.show({
title: '请求失败',
content: err.message })
}
}
},
data () {
return {
queryResult: {Data: [], TotalPage: 0},
type: '',
p_name: '',
currentPage: 1
}
}
}



// WEBPACK FOOTER //
// ./src/components/DeclareKeyElementStat.vue